import { APP_STORE_ANDROID_URL } from "@/lib/config"

interface GooglePlayButtonProps {
  className?: string
}

export const GooglePlayButton = ({ className = "" }: GooglePlayButtonProps) => {
  const androidUrl = APP_STORE_ANDROID_URL

  if (!androidUrl) return null

  return (
    <a
      href={androidUrl}
      className={`inline-block transition-opacity hover:opacity-80 ${className}`}
      aria-label="Get it on Google Play"
    >
      <img
        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
        alt="Get it on Google Play"
        className="h-16"
      />
    </a>
  )
}
